import React, { Dispatch, MutableRefObject, SetStateAction, useContext } from 'react';
import { useIntl } from 'react-intl';

import { AppLocale, SHORT_BAND_NAME, SHORT_BAND_NAME_JP } from 'constant';

import { LanguageContext } from 'context/languageContext';
import { useOutsideClick } from 'hooks';

import AutenticateButton from 'components/AutenticateButton';

import {
  Wrapper,
  StyledContainer,
  ListWrapper,
  List,
  Item,
  ItemLink
} from './Menu.styles';

export interface MenuProps {
  showMenu: boolean;
  setShowMenu: Dispatch<SetStateAction<boolean>>;
  className?: string;
  closeButtonRef?: MutableRefObject<HTMLDivElement>;
}

const Menu = ({ showMenu, setShowMenu, className = '', closeButtonRef = null }: MenuProps) => {
  const intl = useIntl();
  const { locale } = useContext(LanguageContext);

  const outsideClickRef = useOutsideClick(() => {
    if (showMenu === true) {
      setShowMenu(!showMenu);
    }
  }, closeButtonRef?.current);

  const menu = [
    { name: intl.formatMessage({ id: 'menu.home' }), link: '/' },
    { name: intl.formatMessage({ id: 'menu.about' }), link: '/about' },
    { name: intl.formatMessage({ id: 'menu.albums' }), link: '/albums' },
    { name: intl.formatMessage({ id: 'menu.songs' }), link: '/songs' },
    { name: intl.formatMessage({ id: 'menu.concerts' }), link: '/tours-and-shows' },
    { name: intl.formatMessage({ id: 'menu.funDome' }), link: '/fan-dome' }
  ];
  const secondaryMenu = [
    {
      name: intl.formatMessage({ id: 'menu.OORNews' }, {
        shortBandName: locale === AppLocale.EN ? SHORT_BAND_NAME : SHORT_BAND_NAME_JP
      }),
      link: `https://oneokrock.com/${locale === AppLocale.EN ? 'en' : 'jp'}/news/`,
      target: '_blank'
    }
  ];

  return (
    <Wrapper className={className} showMenu={showMenu} ref={outsideClickRef}>
      <StyledContainer>
        <AutenticateButton mobileShow />
        <ListWrapper>
          <List>
            {menu.map((item) => (
              <Item key={item.name}>
                <ItemLink to={item.link}>{item.name}</ItemLink>
              </Item>
            ))}
          </List>
        </ListWrapper>
        <ListWrapper>
          <List>
            {secondaryMenu.map((item) => (
              <Item key={item.name}>
                <ItemLink to={item.link} target={item.target}>
                  {item.name}
                </ItemLink>
              </Item>
            ))}
          </List>
        </ListWrapper>
      </StyledContainer>
    </Wrapper>
  );
};

export default Menu;
